// Utils
import {
  find,
  pathOr,
  propEq,
} from './general';
import { t } from '@toolkit/util/i18n';
// Constants
// Actions, Models & Interfaces
import { BasketItemModel, RentalFareModel } from '../models';

const findRentalBaksetItem = (tariffId:number) => find(propEq('rentalFareId', tariffId));

export const getRentalTariffDocuments = (basketItems:BasketItemModel[], tariffId:number) =>
  pathOr(null, ['travelBookingItem', 'visibleDocuments'], findRentalBaksetItem(tariffId)(basketItems));

export const getRentalTariffOrderNumber = (basketItems:BasketItemModel[], tariffId:number) =>
  pathOr(null, ['travelBookingItem', 'orderNumber'], findRentalBaksetItem(tariffId)(basketItems));


export const getMilageText = (fare: RentalFareModel) => {

  if (fare.mileageUnlimited) {
    return t('RentalRate.label.unlimitedMileage');
  }

  if (fare.mileageFreeUnit !== 'km') {
    return t('RentalRate.label.limitedMileageMi', { distance: fare.mileageFreeDistance });
  } else {
    return t('RentalRate.label.limitedMileageKm', { distance: fare.mileageFreeDistance });
  }
};
